import { useEffect, useRef, useState } from "react";
import html2pdf from "html2pdf.js";
import { useParams, useNavigate, Link } from "react-router-dom";
import PublishedVersions from "./PublishedVersions";
import axios from "axios";

const DocumentDetail = () => {
  const { id } = useParams();
  const [document, setDocument] = useState([]);
  const [documentVersions, setDocumentVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchdoc = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`/apiv1/describe_card/${id}`, {});
        setDocument(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error('BĹ‚Ä…d podczas pobierania dokumentĂłw:', error);
      }
    };
    const fetchVersion = async () => {
      try {
        const response = await axios.get(`/apiv1/versions-card/${id}`, {});
        setDocumentVersions(response.data.data);
      } catch (error) {
        console.error('BĹ‚Ä…d podczas pobierania dokumentĂłw:', error);
      }
    };

    fetchdoc();
    fetchVersion();
  }, [id]);
  const pdfRef = useRef();

  const handlePrint = () => {
    window.print();
  };

  const handleSavePDF = () => {
    if (pdfRef.current) {
      const opt = {
        margin: 0.5,
        filename: `karta-${document.numer}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
      };
      html2pdf().set(opt).from(pdfRef.current).save();
    }
  };
  if (!document) return <p>Dokument nie znaleziony.</p>;
  return loading ? (<div className="loading">
    <div className="loading-spinner"></div>
    <div className="loading-text">Ładowanie danych...</div>
  </div>) : (
    <>
      <nav aria-label="breadcrumb">
        <ul className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to={"/"}>Karty</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Podgląd karty
          </li>
        </ul>
      </nav>

      <div ref={pdfRef} id="pdf-content">

        <div className="document-detail">
          <h2>Karta nr {document.CARD_NUMBER}. Wersja {document.VERSION}</h2>
        </div>

        <table className="document-detail-table">
          <tbody>
            <tr><th>Numer karty/rok</th><td>{document.CARD_NUMBER}</td></tr>
            <tr><th>Rodzaj dokumentu</th><td>{document.DOCUMENT_TYPE}</td></tr>
            <tr><th>Temat dokumentu</th><td><ul>{document.DOCUMENT_SUBJECTS.map((subject, index) => (<li key={index}>{subject}</li>))}</ul></td></tr>
            <tr><th>Nazwa dokumentu</th><td>{document.NAME}</td></tr>
            <tr>
              <th>Zakres przedmiotowy dokumentu - opis dokumentu</th>
              <td>
                {document.describe.opis ? document.describe.opis.VALUE_STRING : ""}
              </td>
            </tr>
            <tr>
              <th>Obszar, którego dokument dotyczy</th>
              <td className="document-detail-creator">
                <tr>
                  {document.AREA_TEXT.map((obszar, index) => (
                    <table key={index}>
                      <tbody>
                        <tr><td>Województwo:</td><td>{obszar.wojewodztwo}</td></tr>
                        {obszar.powiat ? (<tr><td>Powiat:</td><td>{obszar.powiat}</td></tr>) : ("")}
                        {obszar.gmina ? (<tr><td>Gmina:</td><td>{obszar.gmina}</td></tr>) : ("")}
                      </tbody>
                    </table>

                  ))}
                </tr>
              </td>
            </tr>
            <tr><th>Znak sprawy</th><td>{document.CASE_MARK}</td></tr>
            <tr>
              <th>Dokument wytworzył</th>
              <td className="document-detail-creator">
                <tr>
                  {document.CREATE_ENTITIES.map((row, index) => (
                    row.REGISTRY_TYPE == "PERSON" ? (
                      <table key={index}>
                        <tbody>
                          <tr><td>Nazwa:</td><td>**********</td></tr>
                          <tr><td>Typ:</td><td>Osoba fizyczna</td></tr>
                        </tbody>
                      </table>
                    ) : (
                      <table key={index}>
                        <tbody>
                          <tr><td>Nazwa:</td><td>{row.NAME}</td></tr>
                          <tr><td>Typ:</td><td>inny</td></tr>
                          <tr><td>Ulica:</td><td>{row.ADDRESS_STREET}</td></tr>
                          <tr><td>Numer domu:</td><td>{row.ADDRESS_HOME_NUMBER}</td></tr>
                          <tr><td>Numer lokalu:</td><td>{row.ADDRESS_FLAT_NUMBER}</td></tr>
                          <tr><td>Miejscowość:</td><td>{row.ADDRESS_CITY}</td></tr>
                          <tr><td>Kod Pocztowy:</td><td>{row.ADDRESS_POSTAL_CODE}</td></tr>
                          <tr><td>Poczta:</td><td>{row.ADDRESS_POST_OFFICE}</td></tr>
                          <tr><td>Regon:</td><td>{row.REGON}</td></tr>
                          <tr><td>NIP:</td><td>{row.NIP}</td></tr>
                        </tbody>
                      </table>
                    )
                  ))}
                </tr>
              </td>
            </tr>
            <tr><th>Data dokumentu</th><td>{document.describe.data_dok ? document.describe.data_dok.VALUE_DATE : ""}</td></tr>
            <tr><th>Dokument zatwierdził</th>
              <td>{document.APPROVE_ENTITY ? (
                <tr>
                  <tr><td>Nazwa:</td><td>{document.APPROVE_ENTITY.NAME}</td></tr>
                  <tr><td>Typ:</td><td>inny</td></tr>
                  <tr><td>Ulica:</td><td>{document.APPROVE_ENTITY.ADDRESS_STREET}</td></tr>
                  <tr><td>Numer domu:</td><td>{document.APPROVE_ENTITY.ADDRESS_HOME_NUMBER}</td></tr>
                  <tr><td>Numer lokalu:</td><td>{document.APPROVE_ENTITY.ADDRESS_FLAT_NUMBER}</td></tr>
                  <tr><td>Miejscowość:</td><td>{document.APPROVE_ENTITY.ADDRESS_CITY}</td></tr>
                  <tr><td>Kod Pocztowy:</td><td>{document.APPROVE_ENTITY.ADDRESS_POSTAL_CODE}</td></tr>
                  <tr><td>Poczta:</td><td>{document.APPROVE_ENTITY.ADDRESS_POST_OFFICE}</td></tr>
                  <tr><td>Regon:</td><td>{document.APPROVE_ENTITY.REGON}</td></tr>
                  <tr><td>NIP:</td><td>{document.APPROVE_ENTITY.NIP}</td></tr>
                </tr>
              ) : (
                <tr>
                  NIE DOTYCZY
                </tr>
              )
              }</td></tr>
            <tr><th>Data zatwierdzenia dokumentu</th><td>{document.describe.data_zatwierdzenia.VALUE_DATE ?? "NIE DOTYCZY"}</td></tr>
            <tr>
              <th>Miejsce przechowywania dokumentu</th>
              <td className="document-detail-place">
                <tr><td>Urząd:</td><td>{document.STORE_PLACE.actual.urzad}</td></tr>
                <tr><td>Grupa użytkowników:</td><td>{document.STORE_PLACE.actual.grupa}</td></tr>
                <tr><td>Ulica:</td><td>{document.STORE_PLACE.actual.ulica}</td></tr>
                <tr><td>Numer domu:</td><td>{document.STORE_PLACE.actual.numer_domu}</td></tr>
                <tr><td>Numer lokalu:</td><td>{document.STORE_PLACE.actual.numer_lokalu}</td></tr>
                <tr><td>Miejscowość:</td><td>{document.STORE_PLACE.actual.miejscowosc}</td></tr>
                <tr><td>Kod Pocztowy:</td><td>{document.STORE_PLACE.actual.kod_pocztowy}</td></tr>
                <tr><td>Poczta:</td><td>{document.STORE_PLACE.actual.poczta}</td></tr>
                <tr><td>Email:</td><td>{document.STORE_PLACE.actual.email}</td></tr>
                <tr><td>Telefon:</td><td>{document.STORE_PLACE.actual.telefon}</td></tr>
                <tr><td>Miejsce przechowywania:</td><td>{document.STORE_PLACE.actual.miejsce_przechowywania}</td></tr>
              </td>
            </tr>
            <tr><th>Adres elektroniczny zawierający odnośnik do dokumentu</th><td><a href={document.describe.adres_elek ? document.describe.adres_elek.VALUE_STRING : ""} >{document.describe.adres_elek ? document.describe.adres_elek.VALUE_STRING : ""}</a></td></tr>
            <tr><th>Czy dokument jest ostateczny</th><td>{document.describe.ostateczny ? (document.describe.ostateczny.VALUE_BOOLEAN ? "TAK" : "NIE") : ("")}</td></tr>
            <tr><th>Czy dokument jest zniszczony</th><td>{document.describe.ostateczny ? (document.describe.zniszczony.VALUE_BOOLEAN ? "TAK" : "NIE") : ("")}</td></tr>
            <tr><th>Numery kart innych dokumentów w sprawie</th><td>{document.describe.numery_kart.VALUE_STRING.map((subject, index) => (<li key={index}><Link to={`/dokument/${subject.ID_CARD}`}>{subject.CARD_NUMBER}</Link></li>))}</td></tr>
            <tr><th>Zaostrzenia dotyczące nieudostępniania informacji</th><td>{document.describe.zastrzezenia.VALUE_STRING}</td></tr>
            <tr><th>Uwagi</th><td>{document.describe.uwagi.VALUE_STRING}</td></tr>
            <tr><th>Obszar, którego dokument dotyczy</th></tr>
          </tbody >
        </table >

        <div className="document-detail-map">
        </div>

      </div >

      <div className="document-detail-buttons">
        <button className="blue-btn" onClick={() => navigate(-1)}>
          Powrót
        </button>
        <button className="blue-btn" onClick={handlePrint}>
          Drukuj
        </button>
        <button className="blue-btn" onClick={handleSavePDF}>
          Zapisz do PDF
        </button>
      </div>

      <PublishedVersions versions={documentVersions} actual_id={id}/>

    </>
  );
};

export default DocumentDetail;
